var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'jsx-dom';
import { listen, memoize } from '@exadel/esl/modules/esl-utils/decorators';
import { UIPPlugin } from '../../core/base/plugin';
/**
 * Note {@link UIPPlugin} custom element definition
 * Container that is associated with a snippet item {@link UIPSnippetsTitle}
 */
export class UIPNote extends UIPPlugin {
    get $inner() {
        return (React.createElement("div", { class: UIPNote.is + '-inner uip-plugin-inner uip-plugin-inner-bg' }));
    }
    get $title() {
        return (React.createElement("div", { class: UIPNote.is + '-title' }, UIPNote.title));
    }
    connectedCallback() {
        super.connectedCallback();
        this.appendChild(this.$title);
        this.appendChild(this.$inner);
    }
    disconnectedCallback() {
        this.removeChild(this.$inner);
        this.removeChild(this.$title);
        super.disconnectedCallback();
    }
    /** Updates note content from the model state changes */
    _onRootStateChange() {
        this.writeContent();
    }
    writeContent() {
        this.$title.textContent = UIPNote.title;
        this.$inner.innerHTML = this.model.note || '';
    }
}
UIPNote.is = 'uip-note';
UIPNote.title = 'Note: ';
__decorate([
    memoize()
], UIPNote.prototype, "$inner", null);
__decorate([
    memoize()
], UIPNote.prototype, "$title", null);
__decorate([
    listen({ event: 'uip:change', target: ($this) => $this.$root })
], UIPNote.prototype, "_onRootStateChange", null);
